import React, { useEffect, useRef, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import Button from '../../components/button/Button'
import Footer from '../../components/footer/Footer'
import Navigation from '../../components/navigation/Navigation'
import './rsvp.css'

import { collection, addDoc, getDocs, onSnapshot, doc, updateDoc, setDoc } from "firebase/firestore"; 
import { db } from '../../firebaseConfig/FirebaseConfig'
import emailjs from '@emailjs/browser';
import { useNavigate } from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';

const renderLoading = () => (
    <div className='loader'>
        <div className='ball'></div>
        <div className='ball'></div>
        <div className='ball'></div>
        <span> loading...</span>
    </div>
)

const renderLoadingData = () => (
    <div className='dataLoader-wrapper'>
        <div className='dataLoader'>
            <div className='dataLoader dataLoader-inner'></div>
        </div>
    </div>
)

function Rsvp() {
    const navigate = useNavigate();

    const form = useRef();
    const toastId = useRef(null);

    const [loadingData, setLoadingData] = useState(false);
    const [loading, setLoading] = useState(false);

    const [guestList, setGuestList] = useState();
    console.log(guestList);
    const [preditionList, setPredictionList] = useState(false);
    
    const [name, setName] = useState();
    const [selectedId, setSelectedId] = useState();
    const [predictions, setPredictions] = useState();
    const [email, setEmail] = useState();
    const [phone, setPhone] = useState();
    const [attendance, setAttendance] = useState();
    const [message, setMessage] = useState();

    useEffect(() => {
        setLoadingData(true);

        const unsub = onSnapshot(collection(db, "guests"), (snapshot) => {
            const data = snapshot.docs.map(doc => ({...doc.data(), id: doc.id}));
            const unrsvpdData = data.filter(guest => guest.rsvpStatus === false);
            setGuestList(unrsvpdData);
            setLoadingData(false);
        })

        return unsub
    }, []);

    useEffect(() => {
        const suggestedData = guestList && guestList.filter(guest => guest?.name?.match(new RegExp(name, 'i', 'g')));
        setPredictions(suggestedData);
    }, [name]);

    const formInputData = [
        // {
        //     type: 'dropdown',
        //     name: 'Name',
        //     id: 'name',
        //     groupLabel: 'Name',
        //     values: guestList && guestList,
        //     onChange: (e) => setName(e.target.value)
        // },
        {
            type: 'input',
            placeholder: "Please search for your name and click on it",
            value: name,
            onchange: e => {
                setName(e.target.value);
                // if(name !== null || undefined) {
                //     setPredictionList(true);
                // } else {
                //     setPredictionList(false);
                // }

                if(name === undefined) {
                    setPredictionList(false);
                } else {
                    setPredictionList(true);
                }
            },
            required: true,
        },
        {
            type: 'email',
            placeholder: "Email Address",
            value: email,
            onchange: e => setEmail(e.target.value),
            required: true,
        },
        {
            type: 'input',
            placeholder: "Phone Number",
            value: phone,
            onchange: e => setPhone(e.target.value),
            required: true,
        },
        {
            type: 'radio',
            placeholder: 'Attending the event?',
            values: [
                {
                    name: 'Yes',
                    value: true
                },
                {
                    name: 'No',
                    value: false
                }
            ],
            required: true
        }
    ]

    const handleRsvp = async (e) => {
        e.preventDefault();

        setLoading(true);

        const sendEmail =  () => { 
            emailjs.sendForm('service_3h5wulo', 'template_flrzogq', form.current, 'user_pf9bomnE9kJSi3pya3mSD')
                .then(result => {
                    navigate('/thankyou-message');
                    setLoading(false);
                })
                .catch(err => {
                    if(! toast.isActive(toastId.current)) {
                        toastId.current = toast.error(`${err.text}`, {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            });
                    }

                    setLoading(false);
                }) 
        }

        const sendCoupleEmail =  () => { 
            emailjs.sendForm('service_3h5wulo', 'template_e6iahyg', form.current, 'user_pf9bomnE9kJSi3pya3mSD')
                .then(result => {
                    navigate('/thankyou-message');
                    setLoading(false);
                })
                .catch(err => {
                    if(! toast.isActive(toastId.current)) {
                        toastId.current = toast.error(`${err.text}`, {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            });
                    }

                    setLoading(false);
                }) 
        }

        if (name, phone, attendance !== undefined) {
            try {
                if(guestList && guestList.find(guest => guest.name === name)){
                    const guestsRef = doc(db, "guests", `${selectedId}`);

                    if(attendance === true) {
                        await setDoc(guestsRef, {
                            rsvpStatus: true,
                            attendance: true,
                            email: email,
                            phone: phone,
                            name: name
                        });
                        if(email !== undefined){
                            sendEmail();
                            // navigate('/thankyou-message');
                        }
                        
                    } else {
                        await setDoc(guestsRef, {
                            rsvpStatus: true,
                            attendance: false,
                            email: email,
                            phone: phone,
                            message: message,
                            name: name
                        });
                        sendCoupleEmail();
                        // navigate('/thankyou-message');
                    }
                } else {
                    setLoading(false);
                    toastId.current = toast.error(`Sorry your name is not in the guest list`, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            } catch (error) {
                console.log(error);
                if(! toast.isActive(toastId.current)) {
                    toastId.current = toast.error(`Invalid data. Please make sure you have selected your name.`, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        });
                }

                setLoading(false);
            }
        } else {
            if(! toast.isActive(toastId.current)) {
                toastId.current = toast.error(`Please fill all the fields`, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    });
            }
            setLoading(false);
        }
        
    }

  return (
    <div className='rsvp'>
        <div className='section_1'>
            <Navigation background="main_bg" />
        </div>

        <div className='section_2'>
            {
                loadingData ? renderLoadingData() : (
                    <Row style={{ width: "100%"}}>
                        <Col md={6} xsm={12} >
                            <h2 className='section_2-title'>YES, I'LL BE THERE</h2>
                            <p className='section_2-title'>Kindly RSVP by July 22nd, 2022</p>
                            <form className='form' ref={form}>
                                {
                                    formInputData.map((item, index) => (
                                        <React.Fragment>
                                            <p className='placeholder'>{item.placeholder || item.name}</p>
                                            {
                                                item.type === 'input' ? (
                                                    <div className='input'>
                                                        <input
                                                            key={index}
                                                            type={item.type}
                                                            name="to_name"
                                                            placeholder={item.placeholder}
                                                            value={item.value}
                                                            onChange={item.onchange}
                                                        />

                                                        {
                                                            name && preditionList && item.placeholder === "Please search for your name and click on it" ? (
                                                                <div className='predictionlist_wrapper'>
                                                                    {
                                                                        predictions && predictions.map((guest, index) => (
                                                                            <p 
                                                                                key={index}
                                                                                className='predictionlist' 
                                                                                onClick={
                                                                                    () => {
                                                                                        setPredictionList(false);
                                                                                        setSelectedId(guest.id);
                                                                                        setName(guest.name)
                                                                                    }
                                                                                } 
                                                                            >
                                                                                {guest.name}
                                                                            </p>
                                                                        ))
                                                                    }
                                                                </div>
                                                            ) : null
                                                        }
                                                    </div>
                                                ) : (<></>) &&
                                                item.type === 'email' ? (
                                                    <div className='input'>
                                                        <input
                                                            key={index}
                                                            type={item.type}
                                                            name="to_email"
                                                            placeholder={item.placeholder}
                                                            value={item.value}
                                                            onChange={item.onchange}
                                                        />
                                                    </div>
                                                ) : (<></>) &&
                                                item.type === 'dropdown' ? (
                                                    <div className='input'>
                                                        <select name='to_name' id={item.id} value={name} onChange={item.onChange}>
                                                            <optgroup label={item.groupLabel}>
                                                                {
                                                                    item.values &&
                                                                    item.values.map((value, index) => (
                                                                        <option key={index} value={value.name}>
                                                                            {value.name}
                                                                        </option>
                                                                    ))
                                                                }
                                                            </optgroup>
                                                        </select>
                                                    </div>
                                                    
                                                ) : (<></>) && 
                                                item.type === "radio" ? (
                                                    <div className='radio'>
                                                        {
                                                            item.values &&
                                                            item.values.map((item, index) => (
                                                                <React.Fragment key={index} className="radio_wrapper" >
                                                                    <input 
                                                                        type="radio" 
                                                                        id={item.name} 
                                                                        name="fav_language" 
                                                                        value={item.value} 
                                                                        // checked={attendance === item.name}
                                                                        onChange={(e)=>setAttendance(e.currentTarget.value === 'true' ? true : false)}
                                                                    />
                                                                    <label for={item.name}>{item.name}</label>
                                                                </React.Fragment>
                                                            ))
                                                        }
                                                    </div>
                                                ) : (<></>)
                                            }
                                        </React.Fragment>
                                        
                                    ))
                                }

                                {
                                    attendance === true || attendance === undefined ? null : 
                                    (
                                        <React.Fragment>
                                            <div className='input'>
                                            <textarea
                                                name='message'
                                                placeholder='Message to the couple'
                                                rows="5"
                                                value={message}
                                                onChange={e => setMessage(e.target.value)}
                                            />
                                        </div>
                                        </React.Fragment>
                                        
                                        
                                    ) 
                                }

                                
                            </form>

                            <Button 
                                content={loading ? renderLoading() : "SUBMIT"}
                                background="main_bg"
                                buttonAction={e => handleRsvp(e)}
                            />
                        </Col>

                        <Col md={6} xsm={12} className='details_card-wrapper'>
                            <div className='details_card'>
                                <div className='details_card-title'>
                                    <h3>THE WEDDING</h3>
                                </div>
                                <div className='details_card-details'>
                                    <p>July 29th, 2022 from 11:30 AM</p>
                                    <p>Zereniti Gardens, Limuru</p>
                                    <p>Kenya</p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                )
            }
            
        </div>

        {/* <Footer background="main_bg"/> */}

        <ToastContainer />
    </div>
  )
}

export default Rsvp